export default {"src":"/_next/static/media/assurance-veterinaire.93e66674.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};